// Steam Barons — Tier-B bundle (CLIENT only). Layers images over Tier-A. Generated by create-mod.
// NEVER import from Game.js / server.js / the sim / tests (pulls the keyArt PNG + globe lib).
import { steamBaronsData } from './bundle.data';
import { CHARACTERS } from './characters';
import keyArt from '../dominion/keyart.png';
import { getGlobe } from '../dominion/atlas/globe-lib';
import boardBg from './backgrounds/steam-barons.png';

export const steamBaronsClient = Object.assign({}, steamBaronsData, {
  characters: CHARACTERS,
  portraits: {},
  keyArt: keyArt,
  atlasAssets: {},
  mapAssets: { 'steam-barons': { boardBg: boardBg } },
  getGlobe: getGlobe,
});

export default steamBaronsClient;
